import { AttributeList, Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const DueDate: React.FC<{ deadline: Date }> = ({ deadline }) => {
  return (
    <Box flexDirection="row" gap="s4">
      <Text.Normal>{i18n.t('performance_process.reviews.common.due_date')}</Text.Normal>
      <AttributeList
        attributes={[
          {
            type: 'date',
            value: new Date(deadline),
            icon: 'calendar',
          },
        ]}
      />
    </Box>
  )
}
